import { render, staticRenderFns } from "./CBodyNameInput.vue?vue&type=template&id=aec11358&"
import script from "./CBodyNameInput.vue?vue&type=script&lang=ts&"
export * from "./CBodyNameInput.vue?vue&type=script&lang=ts&"
import style0 from "./CBodyNameInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports